/*
 *  Plugin para subidas de imagenes, depende de croppie y fineuploader
 */

;(function ($, window, document, undefined) {

    var pluginName = "beNew",
        defaults = {
            $fileInput: '.js-file-input-news',
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;

        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.options.$fileInput = $(this.options.$fileInput);

        this.uploadUrl = this.$element.data('upload-url');

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;

        Plugin.options.$fileInput.on('change', function () {
            Plugin.changeImage(this);
        });
        $('#submit-button').on('click', function () {
            Plugin.readFile($('#imageUpload').get(0));
        });
    };

    Plugin.prototype.changeImage = function (input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $('#new-img').attr('src', e.target.result);
            };

            reader.readAsDataURL(input.files[0]);

        }

    };


    Plugin.prototype.readFile = function (input) {
        var Plugin = this;
        var fileData = new FormData();
        if (input.files && input.files[0]) {

            var file = input.files[0];

            fileData.append('file', file);
            fileData.append('field-name', input.name);
        }

        $( "input, select, textarea" ).each(function( index ) {
            if(!$(this).hasClass('summernote') && !$(this).hasClass('summernote-complete')) {
                if($(this).val()) {
                    fileData.append($(this).attr("name"), $(this).val());
                }
            }else{
                if($(this).summernote("code")!='<p><br></p>') {
                    fileData.append($(this).attr("name"), $(this).summernote("code"));
                }
            }

        });

        Plugin.sendForm(fileData);
    };

    Plugin.prototype.sendForm = function (data) {
        var Plugin = this;
        $.ajax({
            url: window.location.origin + Plugin.uploadUrl,
            type: 'POST',
            data: data,
            contentType: false,
            processData: false,
            success: function (data) {
                Plugin.removeAlerts(data);
                Plugin.throwAlerts(data);
                if(data.redirect){
                    window.location.href = data.redirect;
                }
            },
            error: function (data) {
                Plugin.removeAlerts(data);
                Plugin.throwAlerts(data);
                console.error('Error al cargar la imagen')
            }
        });
        return false;

    };

    Plugin.prototype.removeAlerts = function(){
        $(document).find('.has-error').toggleClass('has-error');
    };

    Plugin.prototype.throwAlerts = function(data){
        var Plugin = this;

        var response = '';

        if(data.responseText){
            response = jQuery.parseJSON(data.responseText);
            if(response.msg && response.msg.ValidationErrors) {
                $.each(response.msg.ValidationErrors, function (index, value) {
                    $('[name=' + index + '], [data-name=' + index + ']').parent().addClass('has-error');
                    $('[name=' + index + '], [data-name=' + index + ']').find('.select2-selection').toggleClass('has-error');
                });
            }
        }
        else{
            response = data;
        }

        console.log(response);
        $.ajax({
            url: window.location.origin + '/alert-template',
            type: 'POST',
            data: {
                msg : response.msg,
                status : response.status
            },
            success: function(data){
                var msg = $('.o-form__msg').html(data);
            },
            error: function(data){
                var msg = $('.o-form__msg').html(data);
            }
        });
    };


// A really lightweight plugin wrapper around the constructor,
// preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin(this, options));
            }
        });
    }

})(jQuery, window, document);
